import React from "react";
import { Col, Row, FullRow } from "../framework/Grid";
import AcquireWebComponent from "../framework/MaterialUI";
import { Dialog } from "material-ui";
import ReleaseNote from "./release-note";
import ListGraphicSection from "../Insights/ListGraphicClarita";
import { getUrlParameterByName } from "../../utils/utility";
import ClientUnits from "./client-units";
import { Link } from "react-router-dom";

import "./dashboard.css";
import InsightAudienceData from "./insight-audience-data";
import sortBy from "lodash/sortBy";
import reverse from "lodash/reverse";
import { setLoginErrorMessage } from "../../actions/App";

class Dashboard extends AcquireWebComponent {
  constructor(props) {
    super(props);
    const cid = getUrlParameterByName("cid");
    if (cid && !isNaN(cid)) {
      this.props.selectClient(parseInt(cid, 10));
    }
    this.state = {
      insightOpen: false,
      graphOpen: false,
      clientWidth: 508,
      statsPeriod: "month2Date",
    };
  }

  handleClose(e) {
    e.preventDefault();

    this.setState({
      insightOpen: false,
      graphOpen: false,
    });
  }

  handleInsightClick(e) {
    e.preventDefault();
    this.setState({
      insightOpen: true,
    });
  }

  handleGraphClick(e) {
    e.preventDefault();
    this.setState({
      graphOpen: true,
    });
  }

  updateDimensions() {
    let width = 520;
    try {
      width =
        (document.getElementsByClassName("dashboard-container")[0].clientWidth *
          0.8) /
        2;
    } catch (e) {
      width = 520;
    }
    this.setState({ clientWidth: width - 10 });
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions.bind(this));

    if (this.props.roleId && this.props.roleId < 51) {
      this.props.getClientStats();
      this.props.getClientSubscriptionStats();
      this.props.getClientTagStats();
      this.props.getInsightsStats(this.state.statsPeriod);
    }
    this.updateDimensions();
    this.props.getDisabledFeatures();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.roleId !== this.props.roleId && nextProps.roleId < 51) {
      this.props.getClientStats();
      this.props.getClientSubscriptionStats();
      this.props.getClientTagStats();
      this.props.getInsightsStats(this.state.statsPeriod);
    }
  }

  handlePeriodChanged(e) {
    this.props.getInsightsStats(e.value);
    this.setState({ statsPeriod: e.value });
  }

  statsContent() {
    if (this.props.roleId < 51) {
      const clientUnits = this.props.client_stats;
      let clientSubs = [];
      const clientTags = [];
      const {
        client_subscription_stats,
        client_tag_stats,
        insights_stats,
      } = this.props;
      if (client_subscription_stats) {
        client_subscription_stats.forEach((stats) => {
          clientSubs.push({ name: stats.key, value: stats.value });
        });
      }
      clientSubs = reverse(
        sortBy(clientSubs, (item) => {
          return item.value;
        }),
      );
      if (client_tag_stats) {
        //clientTags.push({name:'Total', value:client_tag_stats.total})
        clientTags.push({ name: "Active", value: client_tag_stats.active });
        clientTags.push({ name: "Inactive", value: client_tag_stats.inactive });
      }
      return [
        <Row
          key="dashboard-stats-row-1"
          style={{ margin: "20px 10%", minWidth: "1024px" }}
          className="no-padding"
        >
          <div
            className="light-grey-border pt-20 pl-20 bg-white"
            style={{
              float: "left",
              width: this.state.clientWidth + "px",
              minWidth: "500px",
              height: "300px",
              position: "relative",
            }}
          >
            <ListGraphicSection
              title={"Subscriptions"}
              key={"dashboard-subscriptions"}
              data={clientSubs}
              showGraphic={true}
              footer={
                <Link
                  style={{ bottom: "0px", fontSize: "16px" }}
                  className="section-link"
                  to="/dashboard/subscription"
                >
                  View More Subscription
                </Link>
              }
            />
          </div>
          <div
            className="light-grey-border pt-20 pl-20 bg-white"
            style={{
              float: "right",
              width: this.state.clientWidth + "px",
              minWidth: "500px",
              position: "relative",
              height: "300px",
            }}
          >
            <ClientUnits
              title="Clients/Business Units"
              footer={
                <Link
                  className="section-link"
                  to="/dashboard/clients/client-business-info"
                >
                  View More Information
                </Link>
              }
              data={clientUnits}
            />
          </div>
        </Row>,
        <Row
          key="dashboard-stats-row-2"
          style={{ margin: "20px 10%", minWidth: "1024px" }}
          className="no-padding"
        >
          <div
            className="light-grey-border pt-20 pl-20 bg-white"
            style={{
              float: "left",
              width: this.state.clientWidth + "px",
              minWidth: "500px",
              height: "300px",
              position: "relative",
            }}
          >
            <ListGraphicSection
              title={"Tags"}
              key={"dashboard-tags"}
              data={clientTags}
              showGraphic={true}
              footer={
                <Link
                  className="section-link"
                  style={{ bottom: "80px", fontSize: "16px" }}
                  to="/dashboard/tags"
                >
                  View More Information
                </Link>
              }
            />
          </div>
          <div
            className="light-grey-border pt-20 pl-20 bg-white"
            style={{
              float: "right",
              width: this.state.clientWidth + "px",
              minWidth: "500px",
              position: "relative",
              height: "300px",
            }}
          >
            <InsightAudienceData
              title="Data"
              data={insights_stats}
              period={this.state.statsPeriod}
              handlePeriodChanged={this.handlePeriodChanged.bind(this)}
              footer={
                <Link
                  style={{ bottom: "0" }}
                  className="section-link"
                  to="/dashboard/data/insights"
                >
                  View More Information
                </Link>
              }
            />
          </div>
        </Row>,
      ];
    }
  }

  render() {
    const showMain = Boolean(
      (this.props.loginUserDetail && !this.props.loginUserDetail.baroUid) ||
        (this.props.optimizeUserDetail &&
          this.props.optimizeUserDetail.aaUser &&
          parseInt(
            this.props.optimizeUserDetail.aaUser.subscriptionTierId,
            10,
          ) !== 5) ||
        (this.props.loginUserDetail &&
          this.props.loginUserDetail.baroUid &&
          !this.props.optimizeUserDetail &&
          this.props.client_info &&
          parseInt(this.props.client_info.subscriptionTierId, 10) !== 5) ||
        (this.props.loginUserDetail &&
          this.props.loginUserDetail.baroUid &&
          !this.props.optimizeUserDetail &&
          !this.props.client_info &&
          isNaN(this.props.selected_client) &&
          this.props.selected_client.indexOf("r-") >= 0),
    );
    return (
      <div
        className="dashboard-container"
        style={{
          background: "#FFFFFF",
          marginTop: "-20px",
          paddingTop: "20px",
          marginBottom: "-20px",
          paddingBottom: "20px",
          minWidth: "1480px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            fontSize: "24px",
            marginTop: "200px",
            height: "500px",
            display: showMain ? "none" : "display",
          }}
        >
          Data loading...{" "}
          <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
        </div>
        <div
          style={{
            margin: "20px 10%",
            background: "#FFFFFF",
            display: showMain ? "block" : "none",
          }}
          className="light-grey-border"
        >
          <FullRow
            className="no-padding-bottom mb-5 pt-20 text-center"
            style={{ minWidth: "1024px" }}
          >
            <div className="no-margin-top no-margin-bottom dashboard-title">
              Welcome to your AudienceAnywhere Dashboard!
            </div>
            <div className="dashboard-title-line mt-10 mb-20">
              Be sure to access your dashboard often to view platform metrics.
            </div>
          </FullRow>
        </div>
        {showMain && this.statsContent()}
        <Row
          key="release-note-and-video"
          style={{
            margin: "20px 10%",
            minWidth: "1024px",
            display: showMain ? "block" : "none",
          }}
          className="no-padding"
        >
          <div
            className="light-grey-border pt-20 pl-20 pr-20 bg-white"
            style={{
              float: "left",
              width: this.state.clientWidth + "px",
              minWidth: "500px",
              height: "300px",
              position: "relative",
              overflowY: "auto",
            }}
          >
            <ReleaseNote />
          </div>
          <div
            className="light-grey-border pt-20 pl-20 pr-20 bg-white"
            style={{
              float: "right",
              width: this.state.clientWidth + "px",
              minWidth: "500px",
              position: "relative",
              height: "300px",
            }}
          >
            <div style={{ margin: "0", background: "#fff" }}>
              <h5
                className="no-margin-top no-margin-bottom mb-20"
                style={{ fontWeight: "bold", fontSize: "24px" }}
              >
                Videos
              </h5>
              <Row className="no-margin-bottom no-padding">
                <Col xs="6" sm="6" md="6" lg="6">
                  <Dialog
                    modal={false}
                    open={this.state.insightOpen}
                    onRequestClose={this.handleClose.bind(this)}
                    ref={(el) => (this._insightVideoBox = el)}
                    bodyClassName="insight-video-body"
                    bodyStyle={{ padding: "0 0 0 0", maxHeight: "433px" }}
                  >
                    <div className="video-box-title">
                      <a
                        onClick={(e) => {
                          this.handleClose(e);
                        }}
                      >
                        X
                      </a>
                    </div>
                    <iframe
                      src="https://player.vimeo.com/video/196499808?autoplay=1&hd=1&show_title=1&show_byline=1&show_portrait=0&fullscreen=1"
                      width="770"
                      height="433"
                      frameBorder="0"
                      allowFullScreen
                    ></iframe>
                  </Dialog>
                  <a
                    href="#"
                    target="_blank"
                    onClick={(e) => {
                      this.handleInsightClick(e);
                    }}
                  >
                    <img
                      className="aw-image"
                      src="/images/acquireinsight.jpg"
                      alt=""
                    />
                  </a>
                </Col>
                <Col cs="6" sm="6" md="6" lg="6">
                  <Dialog
                    modal={false}
                    open={this.state.graphOpen}
                    onRequestClose={this.handleClose.bind(this)}
                    ref={(el) => (this._graphVideoBox = el)}
                    bodyStyle={{ padding: "0 0 0 0" }}
                    bodyClassName="graph-video-body"
                  >
                    <div className="video-box-title">
                      <a
                        onClick={(e) => {
                          this.handleClose(e);
                        }}
                      >
                        X
                      </a>
                    </div>
                    <iframe
                      src="https://player.vimeo.com/video/189844803?autoplay=1&hd=1&show_title=1&show_byline=1&show_portrait=0&fullscreen=1"
                      width="770"
                      height="433"
                      frameBorder="0"
                      allowFullScreen
                    ></iframe>
                  </Dialog>
                  <a
                    href="#"
                    target="_blank"
                    onClick={(e) => {
                      this.handleGraphClick(e);
                    }}
                  >
                    <img
                      className="aw-image"
                      src="/images/acquiregraph.jpg"
                      alt=""
                    />
                  </a>
                </Col>
              </Row>
            </div>
          </div>
        </Row>

        <Row
          key="notification-support-section"
          style={{
            margin: "20px 10% 30px",
            minWidth: "1024px",
            display: showMain ? "block" : "none",
          }}
          className="no-padding"
        >
          <div
            className="light-grey-border pt-20 pl-20 pr-20 bg-white"
            style={{
              float: "left",
              width: this.state.clientWidth + "px",
              minWidth: "500px",
              height: "180px",
              position: "relative",
              overflowY: "auto",
            }}
          >
            <div
              style={{
                margin: "0px",
                fontWeight: "350",
                padding: "0px",
                height: "150px",
                background: "#fff",
              }}
            >
              <h5
                className="no-margin-top"
                style={{ fontWeight: "bold", fontSize: "24px" }}
              >
                Notifications
              </h5>
            </div>
          </div>
          <div
            className="light-grey-border pt-20 pl-20 pr-20 bg-white"
            style={{
              float: "right",
              width: this.state.clientWidth + "px",
              minWidth: "500px",
              position: "relative",
              height: "180px",
            }}
          >
            <div
              style={{
                margin: "0",
                fontWeight: "350",
                padding: "0px",
                height: "150px",
                background: "#fff",
                fontSize: "16px",
              }}
            >
              <h5
                className="no-margin-top mb-10"
                style={{ fontWeight: "bold", fontSize: "24px" }}
              >
                Support
              </h5>
              <div className="mb-10" style={{ fontWeight: "600" }}>
                Contact
              </div>
              <div className="mb-10">Business Hours: 8:00 AM - 5:00 PM CST</div>
              <a
                className="aa-color"
                href="mailto:AudienceAnywhere@claritas.com"
              >
                AudienceAnywhere@claritas.com
              </a>
            </div>
          </div>
        </Row>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.jsx